(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nf-eu-sword-simple-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const bind = (root) => {
      if (root.dataset.nfEuSimpleBundleBound === 'true') return;
      const form = root.closest('form');
      const choice = root.querySelector('[data-nf-eu-simple-bundle-choice]');
      const status = root.querySelector('[data-nf-eu-simple-bundle-status]');
      const cartLink = root.querySelector('[data-nf-eu-simple-bundle-cart]');
      const addButton = form?.querySelector('[data-nf-add]');
      const addLabel = addButton?.querySelector('[data-nf-add-label]');
      const dynamicPayment = form?.querySelector('.nf-live-dynamic-payment');
      if (!form || !choice || !status || !addButton) return;

      root.dataset.nfEuSimpleBundleBound = 'true';
      let submitting = false;

      const syncChoice = () => {
        if (dynamicPayment) {
          dynamicPayment.hidden = choice.checked;
          dynamicPayment.setAttribute('aria-hidden', choice.checked ? 'true' : 'false');
        }
        if (!choice.checked) {
          status.textContent = '';
          cartLink.hidden = true;
        }
      };

      choice.addEventListener('change', syncChoice);
      syncChoice();

      form.addEventListener('submit', async (event) => {
        if (!choice.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (submitting) return;

        const parentInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const parentId = Number(parentInput?.value || 0);
        const childId = Number(root.dataset.childVariantId || choice.value || 0);
        const quantity = Math.max(1, Number(quantityInput?.value || 1));
        if (!parentId || !childId) {
          status.textContent = root.dataset.statusError;
          return;
        }

        const originalLabel = addLabel?.textContent || '';
        const parentLine = { id: parentId, quantity };
        const properties = {};
        for (const [name, value] of new FormData(form).entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && String(value).trim()) properties[match[1]] = String(value);
        }
        if (Object.keys(properties).length) parentLine.properties = properties;
        const sellingPlan = form.querySelector('[name="selling_plan"]')?.value;
        if (sellingPlan) parentLine.selling_plan = Number(sellingPlan);

        submitting = true;
        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        if (addLabel) addLabel.textContent = root.dataset.statusAdding;
        status.textContent = root.dataset.statusAdding;
        cartLink.hidden = true;

        try {
          const routeRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${routeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items: [
                parentLine,
                { id: childId, quantity, parent_id: parentId },
              ],
            }),
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.description || result.message || 'Cart request failed');
          status.textContent = root.dataset.statusAdded;
          cartLink.hidden = false;
          if (addLabel) addLabel.textContent = root.dataset.statusAdded;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'nf-eu-simple-bundle', cartAdd: result } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'nf-eu-simple-bundle', cartAdd: result } }));
        } catch (error) {
          status.textContent = root.dataset.statusError;
          cartLink.hidden = false;
          root.dataset.nfEuSimpleBundleError = error instanceof Error ? error.message : String(error);
        } finally {
          submitting = false;
          addButton.disabled = false;
          addButton.removeAttribute('aria-busy');
          window.setTimeout(() => {
            if (addLabel) addLabel.textContent = originalLabel;
          }, 1600);
        }
      }, true);
    };

    const bindAll = (scope = document) => {
      scope.querySelectorAll('[data-nf-eu-simple-bundle]').forEach(bind);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindAll(), { once: true });
    } else {
      bindAll();
    }
    document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nf-mystery-pdp-assurance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    var root = event.target.closest('.t4s-product__info-container');
    if (!root) return;

    var assurance = root.querySelector('[data-nf-mystery-assurance]');
    var variantInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!assurance || !variantInput) return;

    var dataNode = assurance.querySelector('[data-nf-mystery-variants]');
    if (!dataNode) return;

    var variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    window.setTimeout(function () {
      var selected = variants.find(function (variant) {
        return String(variant.id) === String(variantInput.value);
      });
      if (!selected) return;

      var tier = assurance.querySelector('[data-nf-mystery-tier]');
      var weight = assurance.querySelector('[data-nf-mystery-weight]');
      if (tier) tier.textContent = selected.tier;
      if (weight) weight.textContent = selected.weight;
    }, 0);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nf-mystery-shipping-preview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    var productInfo = event.target.closest('.t4s-product__info-container');
    if (!productInfo) return;

    var delivery = productInfo.querySelector('[data-nf-mystery-delivery]');
    if (!delivery) return;

    if (event.target.matches('[data-nf-mystery-country]')) {
      var option = event.target.options[event.target.selectedIndex];
      var transit = delivery.querySelector('[data-nf-mystery-transit]');
      var duty = delivery.querySelector('[data-nf-mystery-duty]');
      if (transit) transit.textContent = option.dataset.transit;
      if (duty) duty.textContent = option.dataset.duty;
      return;
    }

    var variantInput = productInfo.querySelector('form[action*="/cart/add"] [name="id"]');
    var dataNode = delivery.querySelector('[data-nf-delivery-variants]');
    if (!variantInput || !dataNode) return;

    var variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    window.setTimeout(function () {
      var selected = variants.find(function (variant) {
        return String(variant.id) === String(variantInput.value);
      });
      var weight = delivery.querySelector('[data-nf-delivery-weight]');
      if (selected && weight) weight.textContent = selected.weight;
    }, 0);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nf-pdp-shipping-type-calculator"] && !Shopify.designMode) return;
  try {
    (()=>{const roots=()=>Array.from(document.querySelectorAll('[data-nf-shipping-type-calculator]'));const visibleQuantity=root=>{const scope=root.closest('.t4s-product__info-container')||root.parentElement||document;const local=Array.from(scope.querySelectorAll('input[name="quantity"]'));const global=Array.from(document.querySelectorAll('input[name="quantity"]'));const visible=input=>{const rect=input.getBoundingClientRect();return input.type!=='hidden'&&input.offsetParent!==null&&!input.disabled&&rect.width>0&&rect.height>0&&rect.right>0&&rect.left<window.innerWidth};return local.find(visible)||global.find(visible)||local.find(input=>input.type!=='hidden')||global.find(input=>input.type!=='hidden')||local[0]||global[0]};const format=(root,cents)=>`${root.dataset.nfCurrencyPrefix}${(cents/100).toFixed(2)}`;const sync=root=>{const select=root.querySelector('[data-nf-country]');const option=select?.options[select.selectedIndex];const countryState=option?.dataset.countryState||root.dataset.nfCountryState||'checkout';const quantityInput=visibleQuantity(root);const quantity=Math.max(1,Math.trunc(Number(quantityInput&&quantityInput.value)||1));const unit=root.querySelector('[data-nf-unit]');const quantityNode=root.querySelector('[data-nf-quantity]');const estimate=root.querySelector('[data-nf-estimate]');const status=root.querySelector('[data-nf-status]');quantityNode.textContent=String(quantity);root.dataset.nfCountryState=countryState;if(countryState==='unavailable'){unit.textContent=root.dataset.nfCalculated;estimate.textContent=root.dataset.nfUnavailable;status.textContent=root.dataset.nfCountryCode==='SG'?root.dataset.nfRegionalNotice:root.dataset.nfUnavailableStatus;return}if(countryState==='checkout'){unit.textContent=root.dataset.nfCalculated;estimate.textContent=root.dataset.nfCalculated;status.textContent=root.dataset.nfCheckoutStatus;return}if(root.dataset.nfModelState!=='modeled'){unit.textContent=root.dataset.nfCalculated;estimate.textContent=root.dataset.nfCalculated;status.textContent=root.dataset.nfUnmodeledStatus;return}const cents=Number(root.dataset.nfUnitCents);const unitText=format(root,cents);unit.textContent=unitText;estimate.textContent=`${unitText} × ${quantity} = ${format(root,cents*quantity)}`;status.textContent=root.dataset.nfModeledStatus};const syncAll=()=>roots().forEach(sync);const bind=root=>{if(root.dataset.nfBound==='true')return;root.dataset.nfBound='true';root.querySelector('[data-nf-country]')?.addEventListener('change',()=>sync(root));sync(root)};const init=()=>roots().forEach(bind);document.addEventListener('input',event=>{if(event.target.matches('input[name="quantity"]'))syncAll()});document.addEventListener('change',event=>{if(event.target.matches('input[name="quantity"]'))syncAll()});document.addEventListener('click',event=>{if(event.target.closest('[data-quantity-selector],.t4s-quantity-selector'))setTimeout(syncAll,0)});document.addEventListener('shopify:section:load',init);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init()})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nf-product-quantity-restore"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.querySelector('[data-nf-quantity-restore-config]');
    const main = document.getElementById('MainContent');
    if (!config || !main) return;
    const currentVariantIds = new Set((config.dataset.variantIds || '').split(',').filter(Boolean));

    const isRendered = (element) => {
      if (!element) return false;
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.display !== 'none'
        && style.visibility !== 'hidden'
        && Number(style.opacity || 1) > 0
        && rect.width > 0
        && rect.height > 0
        && rect.right > 0
        && rect.left < document.documentElement.clientWidth;
    };

    const clamp = (input) => {
      const minimum = Number.parseInt(input.min || '1', 10) || 1;
      const maximum = input.max ? Number.parseInt(input.max, 10) : Number.POSITIVE_INFINITY;
      const value = Number.parseInt(input.value || String(minimum), 10);
      return Math.min(Math.max(Number.isFinite(value) ? value : minimum, minimum), maximum);
    };

    const emitQuantity = (input) => {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    const enhanceForm = (form) => {
      if (!isRendered(form)) return;
      if (form.closest('.t4s-sticky-atc, [data-sticky-addtocart], #t4s-mini_cart, cart-drawer, .t4s-drawer')) return;
      if (form.querySelector('.nf-quantity-restore')) return;

      const variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (!currentVariantIds.has(String(variantInput?.value || ''))) return;

      const quantityInputs = [...form.querySelectorAll('input[name="quantity"]')];
      if (quantityInputs.some((input) => input.type !== 'hidden' && isRendered(input))) return;

      const addButton = form.querySelector('[data-nf-add], button[name="add"], [data-action-atc], button[type="submit"], input[type="submit"]');
      if (!isRendered(addButton)) return;

      const input = quantityInputs.find((item) => item.type === 'hidden') || document.createElement('input');
      input.type = 'number';
      input.name = 'quantity';
      input.min = input.min || '1';
      input.step = input.step || '1';
      input.value = String(clamp(input));
      input.inputMode = 'numeric';
      input.autocomplete = 'off';
      input.hidden = false;
      input.removeAttribute('hidden');
      input.classList.add('nf-quantity-restore__input');

      const wrapper = document.createElement('div');
      wrapper.className = 'nf-quantity-restore';

      const label = document.createElement('span');
      label.className = 'nf-quantity-restore__label';
      label.textContent = config.dataset.label;

      const controls = document.createElement('div');
      controls.className = 'nf-quantity-restore__controls';

      const decrease = document.createElement('button');
      decrease.type = 'button';
      decrease.className = 'nf-quantity-restore__button';
      decrease.setAttribute('aria-label', config.dataset.decrease);
      decrease.textContent = '−';

      const increase = document.createElement('button');
      increase.type = 'button';
      increase.className = 'nf-quantity-restore__button';
      increase.setAttribute('aria-label', config.dataset.increase);
      increase.textContent = '+';

      const updateButtons = () => {
        const value = clamp(input);
        const minimum = Number.parseInt(input.min || '1', 10) || 1;
        const maximum = input.max ? Number.parseInt(input.max, 10) : Number.POSITIVE_INFINITY;
        decrease.disabled = value <= minimum;
        increase.disabled = value >= maximum;
      };

      decrease.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const step = Number.parseInt(input.step || '1', 10) || 1;
        input.value = String(clamp(input) - step);
        input.value = String(clamp(input));
        updateButtons();
        emitQuantity(input);
      }, true);

      increase.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const step = Number.parseInt(input.step || '1', 10) || 1;
        input.value = String(clamp(input) + step);
        input.value = String(clamp(input));
        updateButtons();
        emitQuantity(input);
      }, true);

      input.addEventListener('change', (event) => {
        event.stopPropagation();
        input.value = String(clamp(input));
        updateButtons();
      });

      input.addEventListener('input', updateButtons);
      controls.append(decrease, input, increase);
      wrapper.append(label, controls);

      const actionArea = addButton.closest('.nf-live-actions, .t4s-product-form__buttons, [data-product-form-buttons]') || addButton;
      actionArea.before(wrapper);
      updateButtons();
    };

    const scan = () => {
      const forms = new Set([
        ...main.querySelectorAll('form[action*="/cart/add"]'),
        ...main.querySelectorAll('form[data-type="add-to-cart-form"]'),
      ]);
      forms.forEach(enhanceForm);
    };

    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        scan();
      });
    };

    scan();
    new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  })();
  } catch(e) { console.error(e); }
})();

})();
